export function reactivationEmailMethodIsDiscountValid(
  discountStatus: boolean | undefined,
  discountEndsAt: string | null | undefined
): boolean {
  const discountNotExpired = discountEndsAt
    ? new Date(discountEndsAt) > new Date()
    : true;
  return Boolean(discountStatus) && discountNotExpired;
}
